
/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class ContentViewDomAPI
 * @hideconstructor
 * @classdesc API class that is used to access the content view
 */
define([
	'../ContentViewDomAPI',
	'../../../../../../lib/@waca/dashboard-common/dist/core/APIFactory'
], (ContentViewDomAPI, APIFactory) => {
	class ContentViewImpl {

		constructor(node) {
			this.domNode = node;
		}

		getAPI() {
			if (!this._api){
				this._api =  APIFactory.createAPI(this, [ContentViewDomAPI]);
			}
			return this._api;
		}

		/**
		 * @function ContentViewDomAPI#cloneNode
		 * @description Clone and return the dom node used by the view
		 * @return {Node} dom node
		 */
		cloneNode() {
			return this.domNode.cloneNode();
		}

		/**
		 * @function ContentViewDomAPI#getNode
		 * @description Return the dom node used by the view
		 * @return {Node} dom node
		 */
		getNode() {
			return this.domNode;
		}

		/**
		 * @function ContentViewDomAPI#getBoundingClientRect
		 * @description Return the client rectangle of the dom node used by the content view
		 * @return {Object} clientRect
		 * @return {Number} clientRect.top
		 * @return {Number} clientRect.left
		 * @return {Number} clientRect.bottom
		 * @return {Number} clientRect.right
		 * @return {Number} clientRect.height
		 * @return {Number} clientRect.width
		 */
		getBoundingClientRect() {
			const clientRect = this.domNode.getBoundingClientRect();
			return {
				top: clientRect.top,
				left: clientRect.left,
				bottom: clientRect.bottom,
				right: clientRect.right,
				height: clientRect.height,
				width: clientRect.width
			};
		}
	}


	return ContentViewImpl;
});
